import React, { useState, useEffect } from 'react';
import "./suggestion-bar.css";
import SuggestionCard from "./SuggestionCard";
import { images } from "../../constants";
import PropTypes from "prop-types";
import { useTranslation, initReactI18next } from "react-i18next";
import i18n from "i18next";
import translationEN from "../../constants/locales/en/translation.json";
import translationID from "../../constants/locales/id/translation.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

const SuggestionBar = ({ words, editorRef, onRemove, webSocket }) => {
  const [isShown, setIsShown] = useState(true);
  const [groupWords, setGroupWords] = useState([]);
  const [highlighted, setHighlighted] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setGroupWords(aggregateWords(words)); 
  }, [words]);

  const aggregateWords = (words) => {
    const wordMap = {};
    words.forEach((word) => {
      const key = word.originalWord.toLowerCase() + " " + word.errorType;
      if (!wordMap[key] ) {
        wordMap[key] = {
          sameWords: [],
          difOffset: word.replacement.length - word.originalWord.length,
        };
      }
      wordMap[key].sameWords.push(word);
    });

    return wordMap; 
  };

  const toggleSuggestionBar = () => {
    setIsShown(!isShown);
  };

  // istanbul ignore next
  const handleCardClick = (word) => {
    setHighlighted(word);
  };

  const renderSuggestionCards = () => {
    if (words.length === 0) {
      return (
        <div className="no-suggestion">
          <p className="title" data-testid="no-suggestions">{t("no_suggestions")}</p>
          <img src={images.no_suggestions} alt="No suggestions yet" />
        </div>
      );
    } else {
      return (
        <div className="all-suggestions">
          <p className="title" data-testid="all-suggestions">{t("all_suggestions")} ({words.length})</p>
          <div className="suggestion-cards" data-testid="suggestion-card">
          {words.map((word, index) => (
            // 
            <SuggestionCard
              key={index}
              word={word}
              onCardClick={() => handleCardClick(word)}
              onClearHighlight={() => setHighlighted(null)}
              highlighted={highlighted}
              groupWords={groupWords}
              editorRef={editorRef}
              onRemove={onRemove}
              webSocket={webSocket}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          ))}
          </div>
        </div>
      );
    }
  };

  return (
    <div className="suggestion-bar-container">
      {isShown ? (
        <div className="suggestion-bar">
          <div data-testid="hide" className="hide-suggestion" onClick={toggleSuggestionBar}>
            <p>{t("hide_suggestions")}</p>
          </div>
          {renderSuggestionCards()}
        </div>
        ) : (
        <div data-testid="show" className="show-suggestion" onClick={toggleSuggestionBar}>
          <p>&lt; {words.length === 0 ? t("show_suggestions") : words.length + " " + t("suggestions")}</p>
        </div>
      )}
    </div>
  );
};

SuggestionBar.propTypes = {
  words: PropTypes.arrayOf(
    PropTypes.shape({
      errorType: PropTypes.string,
      originalWord: PropTypes.string,
      replacement: PropTypes.string,
      offset: PropTypes.number,
      deleteCount: PropTypes.number,
    })
  ),
  editorRef: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default SuggestionBar;
